import type { Country } from '@seek/chalice-types';
import type { Zone } from '@seek/audience-zones';

const countryToZoneLookup: Record<Country, Zone> = {
  AU: 'anz-1',
  NZ: 'anz-2',
  HK: 'asia-1',
  TH: 'asia-3',
  ID: 'asia-4',
  MY: 'asia-5',
  PH: 'asia-6',
  SG: 'asia-7',
};

export default (country: Country): Zone => {
  const zone = countryToZoneLookup[country];
  if (zone) {
    return zone;
  }
  throw new Error('invalid/unsupported country');
};
